import trackingResultsController from './tracking-results.controller';
import trackingResultsView from './tracking-results.view.html';
import './tracking-results.scss';
import './tracking-item-summary.scss';
import './tracking-export-item.scss';
import './tracking-redelivery.scss';

const trackingResultsComponent = {
  template: trackingResultsView,
  controller: trackingResultsController,
  controllerAs: 'vm'
};

export default trackingResultsComponent;


// WEBPACK FOOTER //
// ./src/components/trackingresults/tracking-results.component.js